<div class="size">
  <button mat-icon-button
          (click)="decreaseFontSize($event)"
          [disabled]="!enabled">
    -
  </button
  ><input #input
          type="number"
          [value]="_fontSize"
          (change)="setEncodedFontSize($event.target.value)"
          min="{{minFontSize}}"
          [attr.readonly]="enabled ? undefined : true"
  /><button mat-icon-button
           (click)="increaseFontSize($event)"
           [disabled]="!enabled">
    +
  </button>
</div>
